import { IsNotEmpty, MaxLength, IsDefined, IsPositive, IsNumber, IsNumberString, Validate, ValidateNested} from 'class-validator';
import { computed } from 'mobx';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class QuoteGDPRDataService extends DataService<typeof Model.GDPR.Logic.ViewModels.QuoteGDPRItem, Model.GDPR.Logic.ViewModels.QuoteGDPRItem, QuoteGDPRItem> {
	protected map(entity: Model.GDPR.Logic.ViewModels.QuoteGDPRItem): QuoteGDPRItem {
		return new QuoteGDPRItemModel(entity);
	}

	static make(ctx?: any): QuoteGDPRDataService {
		return new QuoteGDPRDataService(ctx, ctx => ctx.QuotesGDPR);
	}

}

export class QuoteGDPRItemModel extends EntityModel<Model.GDPR.Logic.ViewModels.QuoteGDPRItem, QuoteGDPRItem> implements QuoteGDPRItem {
	@property<QuoteGDPRItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<QuoteGDPRItemModel>(o => o.entity.clientId, (o, value) => o.entity.clientId = value)
	public clientId: number;


	@property<QuoteGDPRItemModel>(o => o.entity.status, (o, value) => o.entity.status = value)
	public status: number;

	public languageCode: string;

	@property<QuoteGDPRItemModel>(o => o.entity.travelRegionId, (o, value) => o.entity.travelRegionId = value)
	public travelRegionId: number;

	@property<QuoteGDPRItemModel>(o => o.entity.travelRegionCode, (o, value) => o.entity.travelRegionCode = value)
	public travelRegionCode: string;

	@property<QuoteGDPRItemModel>(o => o.entity.dateFrom, (o, value) => o.entity.dateFrom = value)
	public dateFrom: Date;

	@property<QuoteGDPRItemModel>(o => o.entity.dateTo, (o, value) => o.entity.dateTo = value)
	public dateTo: Date;

	@property<QuoteGDPRItemModel>(o => o.entity.quoteNumber, (o, value) => o.entity.quoteNumber = value)
	public quoteNumber: string;

	@property<QuoteGDPRItemModel>(o => o.entity.agentId, (o, value) => o.entity.agentId = value)
	public agentId?: number;

	@property<QuoteGDPRItemModel>(o => o.entity.agentName, (o, value) => o.entity.agentName = value)
	public agentName: string;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: {};

	@property<QuoteGDPRItemModel>(o => o.entity.paxs, (o, value) => o.entity.paxs = value)
	public paxs: any[];

	@computed
	public get statusText(): string {
		switch (this.entity.status) {
			case 0:
				return 'Quote';
			case 1:
				return 'Booking';
			case 2:
				return 'Confirmed';
			case 3:
				return 'Closed';
			case 4:
				return 'Cancelled';
		}
		return null;
	}
}



// WEBPACK FOOTER //
// ./src/app/gdpr/clients/form/quote-gdpr-form.data.ts